import { ISymbolInfo } from "@/services/trade/symbols";

type OperationType = "Buy" | "Sell";

export function calculateLotValue(
    symbolInfo: ISymbolInfo,
    lotSize: string | number,
    operationType: OperationType,
    isForex: boolean,
    bid: number,
    ask: number
): number {
    let value = Number(lotSize) * (symbolInfo?.contractSize ?? 0);

    if (!isForex) {
        value = value * (operationType === "Sell" ? bid : ask);
    }

    return value;
}